import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, TextField, Button, Typography, Alert, useTheme } from '@mui/material';
import { login, selectAuthError } from '../../redux/user/user.actions';
import { selectLoading } from '../../redux/loading/loading.actions';
import discoveryIconWhite from '../../assets/icons/discovery_icon_white.png';
import discoveryIconBlack from '../../assets/icons/discovery_icon_black.png';

// Login com a identidade do Orby (item 3 / acesso "somente Orby"): NÃO menciona o
// AloDesk. Usa a mesma autenticação da plataforma; ao entrar, o login redireciona
// para /orby (ver action `login`). Mantém a surpresa — o usuário só vê o Orby.
const OrbyLogin = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const authError = useSelector(selectAuthError);
  const loading = useSelector(selectLoading);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = useCallback((e) => {
    if (e) e.preventDefault();
    if (!email || !password) return;
    dispatch(login(email, password, true));
  }, [dispatch, email, password]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: theme.palette.background.default,
        p: 2,
      }}
    >
      <Box
        component="form"
        onSubmit={handleLogin}
        sx={{ width: '100%', maxWidth: 380, display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center' }}
      >
        <Box
          component="img"
          src={theme.palette.mode === 'dark' ? discoveryIconWhite : discoveryIconBlack}
          alt="Orby"
          sx={{ width: 72, height: 72, objectFit: 'contain', mx: 'auto' }}
        />
        <Typography variant="h5" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>
          Orby
        </Typography>
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 1 }}>
          Entre para conversar com o Orby
        </Typography>
        {authError && (
          <Alert severity="error">{typeof authError === 'string' ? authError : 'Não foi possível entrar.'}</Alert>
        )}
        <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus fullWidth size="small" />
        <TextField label="Senha" type="password" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth size="small" />
        <Button type="submit" variant="contained" disabled={loading || !email || !password} sx={{ py: 1.2, textTransform: 'none', fontWeight: 600 }}>
          {loading ? 'Entrando...' : 'Entrar'}
        </Button>
      </Box>
    </Box>
  );
};

export default OrbyLogin;
